import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=0dd64e16&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=js&"
export * from "./ItemList.vue?vue&type=script&lang=js&"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=0dd64e16&scoped=true&lang=css&"
import style1 from "./ItemList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd64e16",
  null
  
)

export default component.exports